import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.open = true;
    // if ("showModal" in this.dialogTarget) {
    //   this.dialogTarget.showModal();
    // } else {
    //   this.dialogTarget.show();
    // }
  }
}
